import { getMyBills } from '@/api/bill.api';
import { queryKeys } from '@/queryKeys';
import { useQuery } from '@tanstack/react-query';

export const useGetMyBills = () =>
  useQuery({
    queryKey: queryKeys.bills,
    queryFn: getMyBills,
  });
